import * as React from "react";
import {connect} from "react-redux";
import {CC_EMAIL_ID} from "utils/variables";
import "egold/styles.scss";
import Button from "myshubhlife-component/button";
import BasicCard from "myshubhlife-component/card";
import {IReduxState} from "reducers";
import {IBankAccountDetails, IEgoldUserDetails, IVerifySellPrice} from "StateInterface";
import {clearBankDetailsValidResponse, clearVerifyPrice, sellGold} from "egold/actions";
import {vendor} from "egold/egold-config";
import {handleNavigation, routePaths} from "egold/routes";
import {useEffect} from "react";
import {EVENT_NAMES} from "Dashboard/utils";


interface IConnectProps {
    dispatch?: (action: any) => void;
    bankDetails: IBankAccountDetails;
    eGoldUserDetails: IEgoldUserDetails;
    verifySellPrice: IVerifySellPrice; 
    bankDetailsValidStatus: string;
}
enum VALID_STATUS_TYPE {
    SUCCESS = "SUCCESS",
    FAILED = "FAILED",
}
const VerifiedBankAccount = (props: IConnectProps) => {
    const bankAccStr = "************" + Number(props.bankDetails.bankAccount.accountNumber) % 10000;
    useEffect(() => {
        return () => {
            props.dispatch(clearBankDetailsValidResponse());
            props.dispatch(clearVerifyPrice());
        };
    }, [])
    useEffect(() => {
        if (props.bankDetailsValidStatus === VALID_STATUS_TYPE.SUCCESS) {

        } 
        if (props.bankDetailsValidStatus === VALID_STATUS_TYPE.FAILED) {

            handleNavigation(routePaths.ORDER_FAIL);
        }
    }, [props.bankDetailsValidStatus]);
    const handleClickConfirm = () => {
        const bankInfo = {
            account_number: props.bankDetails.bankAccount.accountNumber,
            ifsc: props.bankDetails.bankAccount.ifsc,
            txn_id: props.verifySellPrice.txn_id,
            customer_name: props.bankDetails.bankAccount.beneficiaryName,
            vendor_id: props.eGoldUserDetails.vendor_id,
            bank_name: props.bankDetails.bankAccount.bankName,
        };
        props.dispatch(sellGold(vendor.SAFEGOLD, bankInfo));
    }

    return (
        <div className="verify-page-card-contianer">
            <BasicCard>
                <div className="verify-page-wrapper text-center">
                    <p className="account-heading">Account to be credited</p>
                    <div className="verify-page-bank-details">
                        <p className="account-number">{bankAccStr}</p>
                        <p className="bank-name">{props.bankDetails.bankAccount.bankName}</p>
                    </div>
                    <Button
                        buttonText={"CONFIRM"}
                        onClick={handleClickConfirm}
                        width={"30%"}
                        rounded={true}
                    />
                    <p className="contact-mssg">
                        Please contact us at
                        <span><a className="contact-link" href="mailto:support@myshubhlife.com"> {CC_EMAIL_ID} </a></span>
                        for further support.
                    </p>
                </div>
            </BasicCard>
      </div>
    )
}

const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        bankDetails: state.eGold.eGoldUserDetails.bankAccountDetails,
        eGoldUserDetails: state.eGold.eGoldUserDetails,
        verifySellPrice: state.eGold.verifySellPrice,
        bankDetailsValidStatus: state.eGold.bankDetailsValidStatus,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(VerifiedBankAccount);
